import { useCallback } from 'react';
import { useSetPlayerTags } from 'server';
import { useTranslations } from 'js/hooks/i18n';
import { useGetErrorResponseMessage } from 'js/hooks/server';
import { useShowNotification } from 'js/hooks/useShowNotification';

import { prepareTag } from '../helpers';

export const useUpdatePreferences = ({ refetch, setIsUpdating, setSubmitError }) => {
    const setPlayerTags = useSetPlayerTags();
    const showNotification = useShowNotification();
    const getErrorResponseMessage = useGetErrorResponseMessage();
    const t = useTranslations('playtech.mobile.system.gamingPreference.');

    return useCallback((formData) => {
        const tag = prepareTag(formData);

        setSubmitError();
        setIsUpdating(true);

        (async () => {
            try {
                await setPlayerTags({ tags: [tag] });
                showNotification({ message: t('save.success') });
                refetch(Date.now());
            } catch (error) {
                setSubmitError(getErrorResponseMessage(error));
            } finally {
                setIsUpdating(false);
            }
        })();
    }, [refetch, setSubmitError, setIsUpdating, showNotification, getErrorResponseMessage, t, setPlayerTags]);
};
